import React from "react";
import { Grid, Paper, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import classnames from "classnames";
import useStyles from "./styles";

export default function Error() {
  var classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Paper classes={{ root: classes.paperRoot }}>
        <div className={classes.logotype}>
          {/* <img className={classes.logotypeIcon} src={logo} alt="logo" /> */}
          <Typography
            variant="h3"
            color="primary"
            className={classes.logotypeText}
          >
            SpaceAgeLabs
          </Typography>
        </div>
        <Typography variant="h5" color="primary" className={classes.textRow}>
          Oops. Looks like the page you're looking for no longer exists
        </Typography>
        <Typography variant="h2" color="primary" className={classes.textRow}>
          or
        </Typography>
        <Typography variant="h5" color="primary" className={classes.textRow}>
          You don't have access to perform any action
        </Typography>
        <Typography
          variant="h6"
          color="text"
          colorBrightness="secondary"
          className={classnames(classes.textRow, classes.safetyText)}
        >
          But we're here to bring you back to safety
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/"
          size="large"
          className={classes.backButton}
        >
          Back to Home
        </Button>
      </Paper>
    </Grid>
  );
}
